import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { DataBase } from '@shared/models/login-response.model';
import { StorageService } from '@shared/services/storage/storage.service';
import { LoginService } from '@auth/services/login/login.service';

export const DbGuard: CanActivateFn = async (route, state) => {
  const _storage = inject(StorageService);
  const _service = inject(LoginService);
  const db: DataBase = await _storage.getItem('db');
  if (!db || db.idBase === 0) {
    _service.logout();
    return false;
  }
  return true;
};
